import { Modal } from "@mui/material";
import { Button } from "bootstrap";


export const handleExportThetisXml = async ({
    validationUrl,
    exportUrl,
    axiosHttp,
    setShowConfirmation,
    setExportAction,
    emitToasterMsg,
    fileName = "exported_file.zip",
}) => {
    try {
        const response = await axiosHttp({
            url: validationUrl,
            method: "GET",
        });

        if (response.data === true) {

            setExportAction(() => async () => {
                await executeExport({
                    exportUrl,
                    axiosHttp,
                    emitToasterMsg,
                    fileName,
                });
            });
            setShowConfirmation(true);

        } else {
            await executeExport({
                exportUrl,
                axiosHttp,
                emitToasterMsg,
                fileName,
            });
        }
    } catch (error) {
        emitToasterMsg(
            "error",
            "Export Failed",
            "Unable to validate the export request."
        );

        console.error(error);
    }
};


const executeExport = async ({
    exportUrl,
    axiosHttp,
    emitToasterMsg,
    fileName,
}) => {
    try {
        const res = await axiosHttp({
            url: exportUrl,
            method: "GET",
            responseType: "blob",
        });

        const blob = new Blob([res.data], {
            type: "application/zip",
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = url;
        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);

        emitToasterMsg(
            "success",
            "Export Successful",
            "The file has been exported successfully."
        );
    } catch (error) {
        emitToasterMsg(
            "error",
            "Export Failed",
            "An unexpected error occurred during the export process."
        );

        console.error(error);
    }
}
